module.exports = __webpack_public_path__ + "img/Group 4260.fbb52455.png";